import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";
import {pagination, modal} from "../../../app/services/dataTemplates"

const StatisticsModule = () => {
  return {
    state: {
      prices: {
        loaded: false,
        data: {
          spot: [],
          actual: [],
          company: [],
          labels: []
        },
      }
    },
    mutations,
    actions,
    getters,
  }
};

export default StatisticsModule;



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/statistics/index.js